import { DOCUMENT_CATEGORY, DocumentEntry, DocumentNavItem } from '../../api/app-types/document.app';

export function parseDocumentCategory(input: string | undefined): DOCUMENT_CATEGORY {
	switch (input) {
		case 'DisabilityReport':
			return DOCUMENT_CATEGORY.DISABILITY_REPORT;
		case 'DisabilityKind':
			return DOCUMENT_CATEGORY.DISABILITY_KIND;
		case 'Assignment':
			return DOCUMENT_CATEGORY.ASSIGNMENT;
		case 'Report':
			return DOCUMENT_CATEGORY.REPORT;
		case 'Contact':
			return DOCUMENT_CATEGORY.CONTACT;
		default:
			return DOCUMENT_CATEGORY.UNKNOWN;
	}
}

export const documentCategoryOrder: Record<DOCUMENT_CATEGORY, number> = {
	[DOCUMENT_CATEGORY.DISABILITY_REPORT]: 1,
	[DOCUMENT_CATEGORY.DISABILITY_KIND]: 2,
	[DOCUMENT_CATEGORY.ASSIGNMENT]: 3,
	[DOCUMENT_CATEGORY.REPORT]: 4,
	[DOCUMENT_CATEGORY.CONTACT]: 5,
	[DOCUMENT_CATEGORY.UNKNOWN]: 999,
};

export const documentCategoryTranslationKeys: Record<DOCUMENT_CATEGORY, string> = {
	[DOCUMENT_CATEGORY.DISABILITY_REPORT]: 'client.documents.categories.disability_report',
	[DOCUMENT_CATEGORY.DISABILITY_KIND]: 'client.documents.categories.disability_kind',
	[DOCUMENT_CATEGORY.ASSIGNMENT]: 'client.documents.categories.assignment',
	[DOCUMENT_CATEGORY.REPORT]: 'client.documents.categories.report',
	[DOCUMENT_CATEGORY.CONTACT]: 'client.documents.categories.contact',
	[DOCUMENT_CATEGORY.UNKNOWN]: 'client.documents.categories.unknown',
};

export function mapDocumentCategoryToKey(dc: DOCUMENT_CATEGORY) {
	return documentCategoryTranslationKeys[dc] || 'unknown';
}

export function buildDocumentNavItems(entries: DocumentEntry[]): DocumentNavItem[] {
	return entries.flatMap((e) =>
		(e.externalFileReference ?? []).map((f) => ({
			file: f,
			entryId: e.id,
			entryName: e.name,
			category: e.category,
			createdAt: e.createdAt,
			isReport: e.isReport,
			isFrozen: e.isFrozen,
		})),
	);
}
